import React from 'react'

import styles from './Content.module.scss'
import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { QuestionPreview } from 'components/shared/QuestionPreview/QuestionPreview'

type ContentProps = {
  questions?: { id: number; title: string; description: string }[]
  title?: string
}

export const Content = ({ questions = [], title = '' }: ContentProps) => {
  const total = questions.length

  return (
    <Box className={styles.content} direction="column" tagName="article">
      <h2 className={styles.title}>{title}</h2>
      <List className={styles.list} direction="column">
        {questions.map(({ description, id, title }) => (
          <QuestionPreview {...{ id, total, title, description }} key={id} />
        ))}
      </List>
    </Box>
  )
}
